module.exports = __webpack_public_path__ + "img/marioMoita.5c94a626.webp";